import Vue from 'vue'
import { Collapse } from 'buefy'

// import 'buefy/dist/buefy.css'
import 'buefy/src/scss/utils/_animations.scss'
import 'buefy/src/scss/components/_collapse.scss'

Vue.use(Collapse)